export default __webpack_public_path__ + "static/media/adentis-login-bg.7401d4ae.jpg";